/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimFormGeoCountry
 */
export interface ClaimFormGeoCountry {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClaimFormGeoCountry
     */
    regions: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClaimFormGeoCountry
     */
    name: string;
}

/**
 * Check if a given object implements the ClaimFormGeoCountry interface.
 */
export function instanceOfClaimFormGeoCountry(value: object): value is ClaimFormGeoCountry {
    if (!('regions' in value) || value['regions'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ClaimFormGeoCountryFromJSON(json: any): ClaimFormGeoCountry {
    return ClaimFormGeoCountryFromJSONTyped(json, false);
}

export function ClaimFormGeoCountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimFormGeoCountry {
    if (json == null) {
        return json;
    }
    return {
        
        'regions': json['regions'],
        'name': json['name'],
    };
}

export function ClaimFormGeoCountryToJSON(value?: ClaimFormGeoCountry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'regions': value['regions'],
        'name': value['name'],
    };
}

